import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

import { ArrowLink, PrimaryLink } from '../Common/Links';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import * as styles from './Customization.module.css';

const getAccent = (accentColor) => {
  let accent = styles.white;
  if (accentColor === 'Blue') {
    accent = styles.blue;
  } else if (accentColor === 'Pink') {
    accent = styles.pink;
  }
  return accent;
};

const Customization = ({ heading, mainCard, cards }) => {
  let mainImage = <GatsbyImage alt={mainCard.image.description} image={mainCard.image.gatsbyImageData} />;
  if (mainCard.image.file.contentType === 'image/svg+xml') {
    mainImage = <img src={mainCard.image.file.url} alt={mainCard.image.description} />;
  }
  let mainAccent = getAccent(mainCard.accentColor);
  return (
    <div>
      <h3 className={styles.header}>{heading}</h3>
      <div>
        <div className={[styles.main, mainAccent].join(' ')}>
          <div className={styles.mainLeft}>
            <div>
              {mainCard.subtitle && <div className={styles.superText}>{mainCard.subtitle}</div>}
              <h3>{mainCard.title}</h3>
              <RichTextConverter copy={mainCard.body} />
            </div>
            <div>
              <PrimaryLink className={styles.mainCta} label={mainCard.linkLabel} url={mainCard.linkUrl} isButton />
            </div>
          </div>
          <div className={styles.mainImage}>{mainImage}</div>
        </div>
        <div className={styles.cardGrid}>
          {cards.map((card, i) => {
            const accent = getAccent(card.accentColor);
            return (
              <div className={[styles.card, accent].join(' ')} key={i}>
                <div>
                  {card.subtitle && <div className={styles.superText}>{card.subtitle}</div>}

                  <h4>{card.title}</h4>
                  <RichTextConverter copy={card.body} />
                </div>
                <ArrowLink label={card.linkLabel} url={card.linkUrl} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

Customization.propTypes = {
  // myProp: PropTypes.string.isRequired
};

export default Customization;
